import React, { useEffect, useState, useContext, useRef } from "react";
import _ from "lodash";
import Select from "react-select";
import ConfirmationModal from "../project/ConfirmationModal";
import ToggleButton from "./ToggleButton";
import SpaceConfig from "./SpaceConfig";
import ShutterConfig from "./ShutterConfig";
import { Cutlist } from "../carpenter-view";
import {
  Button,
  Carousel,
  CarouselItem,
  CarouselControl,
  FormGroup,
  Label,
  Input,
  Form,
  ListGroup,
  ListGroupItem,
  FormFeedback,
} from "reactstrap";

import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
  useSearchParams,
} from "react-router-dom";

import {
  getOrderItem,
  customizeOrderItem,
  addAttachmentsToOrderItem,
  addRemarksToOrderItem,
  deleteAttachment,
  removeProjectOverride,
  customizeOrderItemDimension,
} from "./service";

import {
  CloseButton,
  CloseButtonContainer,
  Option,
  OptionsContainer,
  OptionImage,
  ProductContainer,
  ProductInfoContainer,
  ProductImgContainer,
  PropertiesContainer,
  Thumbnail,
  ThumbnailContainer,
} from "./style";

import {
  CustomizationSpinnerContainer,
  Notification,
  Icon,
  Navbar,
  ProductName,
  DimensionInput,
} from "../common/style";

import { AppContext } from "../context";
import { Spinner } from "reactstrap";
import { isMobile, isBrowser } from "react-device-detect";
import { UI_RESTRICTED_PROPERTIES } from "../constants";
import ShutterCustomizationContainer from "./ShutterCustomizationContainer";
import { ProjectSettingsFormGroup } from "../project/style";
import useSearchParamHandler from "../utils";
import { markBomSummaryStale } from "../project/service";

function Personalize() {
  const { currentRoom, projectId, loadRoom } = useOutletContext();
  const params = useParams();
  const [searchParams] = useSearchParams();
  const urlSearchParams = new URLSearchParams(searchParams);

  const groupId = searchParams.get("groupId");
  const orderItemId = searchParams.get("orderItemId");
  const hiddenFileInput = useRef(null);

  const [toggleState, setToggleState] = useState("product");
  const [orderItem, setOrderItem] = useState(null);
  const [secondaryProperties, setSecondaryProperties] = useState({});
  const [projectSettings, setProjectSettings] = useState({});
  const [isNotificationVisible, setIsNotificationVisible] = useState(true);
  const [notificationMessage, setNotificationMessage] = useState({});
  const [isPropertiesMenuLoading, setIsPropertiesMenuLoading] = useState(false);
  const [showAttachmentForm, setShowAttachmentForm] = useState(false);
  const [label, setLabel] = useState("");
  const [remarks, setRemarks] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [showMoreProperties, setShowMoreProperties] = useState(false);
  const [removeOverrideConfirmationOpen, setRemoveOverrideConfirmationOpen] =
    useState(false);
  const toggleOverrideConfirmation = () =>
    setRemoveOverrideConfirmationOpen(!removeOverrideConfirmationOpen);
  const [overridePropertyIdentifier, setOverridePropertyIdentifier] =
    useState("");
  const [customizeShutters, setCustomizeShutters] = useState(false);
  const [dimensions, setDimensions] = useState({
    height: "",
    width: "",
    depth: "",
  });
  const { bomSummary, setBomSummary } = useContext(AppContext);

  const toggleDeleteConfirmation = () =>
    setShowDeleteConfirmation(!showDeleteConfirmation);

  const toggleCustomizeShutters = () =>
    setCustomizeShutters(!customizeShutters);

  const value = useLocation().state;
  const searchValue = value ? value : "";

  const onDismissNotification = () => {
    setIsNotificationVisible(false);
  };

  const handleToggleForm = () => {
    setShowAttachmentForm(!showAttachmentForm);
  };

  const handleCancel = () => {
    setShowAttachmentForm(false);
  };

  const toggleHandler = (newToggleState) => {
    setToggleState(newToggleState);
  };

  const handleDeleteAttachment = (blobId) => {
    toggleDeleteConfirmation();

    return deleteAttachment({ projectId, groupId, orderItemId, blobId })
      .then(() => {
        setIsNotificationVisible(true);
        setNotificationMessage({
          type: "success",
          message: "Attachment Deleted Successfully",
        });
        setAttachments(
          attachments.filter((attachment) => attachment.blobId !== blobId)
        );
        loadRoom(currentRoom.id);
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({ type: "error", message: error });
      })
      .finally(() => {
        loadOrderItem({ loader: true });
      });
  };

  const handleAttachmentUpload = (file) => {
    addAttachmentsToOrderItem({
      projectId,
      groupId,
      orderItemId,
      image: file,
      label,
    })
      .then(() => loadRoom(currentRoom.id))
      .catch(({ error }) => {
        setNotificationMessage({
          text: error,
          type: "danger",
        });
      })
      .finally(() => {
        loadOrderItem({ loader: true });
        setLabel("");
      });

    setShowAttachmentForm(false);
  };

  const handleOptionsChange = (property_uniq_id, option_identifier) => {
    setIsPropertiesMenuLoading(true);
    const productOptions = orderItem.selectedValues;
    productOptions[property_uniq_id] = option_identifier;

    customizeOrderItem({
      projectId,
      groupId,
      orderItemId,
      productOptions,
    })
      .then((order_item) => {
        const secondaryProperties = _.groupBy(
          order_item.property_list.filter(
            (property) =>
              !UI_RESTRICTED_PROPERTIES.includes(property.uniq_id) &&
              order_item.secondary_settings[property.uniq_id]
          ),
          "header_name"
        );

        const productSettings = _.groupBy(
          order_item.property_list.filter(
            (property) =>
              !(
                UI_RESTRICTED_PROPERTIES.includes(property.uniq_id) ||
                order_item.project_settings[property.uniq_id]
              )
          ),
          "header_name"
        );

        setOrderItem({
          ...order_item.customized_item,
          ...{ property_list: productSettings },
          ...{ isContainerChild: order_item.is_submodule },
          ...{ dimensions: order_item.dimensions },
          ...{ selectedValues: order_item.selected_values },
          product: {
            name: order_item.name,
            images: order_item.images,
          },
        });
        setSecondaryProperties({ ...secondaryProperties });
        setProjectSettings({ ...order_item.project_settings });
        setAttachments(order_item.attachments || []);
        setRemarks(order_item.remarks || "");
        markBomSummaryStale(bomSummary, setBomSummary);
        loadRoom(currentRoom.id);
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({ type: "danger", text: error });
        loadOrderItem({ loader: true });
      })
      .finally((_) => setIsPropertiesMenuLoading(false));
  };

  const loadOrderItem = ({ loader = true }) => {
    if (loader) setIsPropertiesMenuLoading(true);

    getOrderItem({
      projectId,
      groupId,
      orderItemId,
    })
      .then((order_item) => {
        const secondaryProperties = _.groupBy(
          order_item.property_list.filter(
            (property) =>
              !UI_RESTRICTED_PROPERTIES.includes(property.uniq_id) &&
              order_item.secondary_settings[property.uniq_id]
          ),
          "header_name"
        );

        const productSettings = _.groupBy(
          order_item.property_list.filter(
            (property) =>
              !(
                UI_RESTRICTED_PROPERTIES.includes(property.uniq_id) ||
                order_item.project_settings[property.uniq_id]
              )
          ),
          "header_name"
        );

        setOrderItem({
          ...order_item.customized_item,
          ...{ property_list: productSettings },
          ...{ isContainerChild: order_item.is_submodule },
          ...{ isContainerCabinet: order_item.is_container },
          ...{ isSpaceConfigChanged: order_item.space_config_changed },
          ...{
            isShutterSizeConfigChanged: order_item.shutter_size_config_changed,
          },
          ...{ spaceConfig: order_item.space_config },
          ...{ renderMetadata: order_item.render_metadata },
          ...{ dimensions: order_item.dimensions },
          ...{ selectedValues: order_item.selected_values },
          product: {
            name: order_item.name,
            images: order_item.images,
          },
        });
        setDimensions({
          height: order_item.dimensions.find((e) => e.key === "height")?.[
            "value"
          ],
          width: order_item.dimensions.find((e) => e.key === "width")?.[
            "value"
          ],
          depth: order_item.dimensions.find((e) => e.key === "depth")?.[
            "value"
          ],
        });

        setSecondaryProperties({ ...secondaryProperties }); // To load show more section
        setProjectSettings({ ...order_item.project_settings });

        setAttachments(order_item.attachments || []);
        setRemarks(order_item.remarks || "");
        setCustomizeShutters(order_item.shutter_color_overridden);
        toggleHandler("product");
      })
      .catch(({ error }) => {
        setNotificationMessage({ type: "danger", text: error });
      })
      .finally((_) => {
        setIsPropertiesMenuLoading(false);
      });
  };

  useEffect(() => {
    setIsPropertiesMenuLoading(true);

    orderItemId && loadOrderItem({ loader: false });
  }, [orderItemId]);

  const handleOrderItemUpdate = (order_item) => {
    // const secondaryProperties = _.groupBy(
    //   order_item.property_list.filter(
    //     (property) =>
    //       !UI_RESTRICTED_PROPERTIES.includes(property.uniq_id) &&
    //       order_item.secondary_settings[property.uniq_id]
    //   ),
    //   "header_name"
    // );
    //
    // const productSettings = _.groupBy(
    //   order_item.property_list.filter(
    //     (property) =>
    //       !(
    //         UI_RESTRICTED_PROPERTIES.includes(property.uniq_id) ||
    //         order_item.project_settings[property.uniq_id]
    //       )
    //   ),
    //   "header_name"
    // );
    //
    // setOrderItem({
    //   ...order_item.customized_item,
    //   ...{ property_list: productSettings },
    //   ...{ isContainerChild: order_item.is_submodule },
    //   ...{ isSpaceConfigChanged: order_item.space_config_changed },
    //   ...{ isShutterSizeConfigChanged: order_item.shutter_size_config_changed },
    //   ...{ spaceConfig: order_item.space_config },
    //   ...{ renderMetadata: order_item.render_metadata },
    //   ...{ dimensions: order_item.dimensions },
    //   ...{ selectedValues: order_item.selected_values },
    // });
    //
    // // To load show more section
    // setSecondaryProperties({ ...secondaryProperties });
    //
    // setProjectSettings({ ...order_item.project_settings });
    // setAttachments(order_item.attachments || []);
    // setRemarks(order_item.remarks || "");
    // setCustomizeShutters(order_item.shutter_color_overridden);
  };

  const handleRemarks = () => {
    addRemarksToOrderItem({ projectId, groupId, orderItemId, remarks })
      .then(() => loadRoom(currentRoom.id))
      .catch(({ error }) => {
        setNotificationMessage({
          text: error,
          type: "danger",
        });
      })
      .finally(() => {
        loadOrderItem({ loader: true });
      });
  };

  const handleRemoveProjectOverride = (propertyIdentifier) => {
    setIsPropertiesMenuLoading(true);
    removeProjectOverride({
      projectId: projectId,
      groupId: groupId,
      orderItemId: orderItemId,
      propertyIdentifier: propertyIdentifier,
    })
      .then((response) => {
        setIsNotificationVisible(true);
        setNotificationMessage({
          type: "success",
          message: response.message,
        });
        loadOrderItem({ loader: true });
        markBomSummaryStale(bomSummary, setBomSummary);
        loadRoom(currentRoom.id);
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({
          type: "error",
          message: error.message,
        });
      })
      .finally((_) => {
        setIsPropertiesMenuLoading(false);
        toggleOverrideConfirmation();
      });
  };

  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = (index) => {
    if (activeIndex === index) return;
    if (animating) return;

    const nextIndex =
      activeIndex === orderItem.product.images.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === 0 ? orderItem.product.images.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  let slides = null;

  if (orderItem) {
    slides = orderItem.product.images.map((image, index) => (
      <CarouselItem
        key={index}
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
      >
        <img src={image} className="mw-100 mh-100" />
      </CarouselItem>
    ));
  }

  const renderCarousel = () => {
    return (
      <Carousel
        interval={false}
        activeIndex={activeIndex}
        next={next}
        previous={previous}
        slide={false}
      >
        {slides}
        {slides.length > 1 && isBrowser && (
          <>
            <CarouselControl
              direction="prev"
              directionText="Previous"
              onClickHandler={previous}
            />
            <CarouselControl
              direction="next"
              directionText="Next"
              onClickHandler={next}
            />
          </>
        )}
      </Carousel>
    );
  };

  const getClassForRenderingProperties = ({ headers, displayType }) => {
    if (headers === "null") return "";

    return displayType === "toggle"
      ? "rounded-1 mt-2 btn-group"
      : "d-flex align-items-center flex-wrap gap-10";
  };

  const renderProperties = ({
    propertyList,
    headers,
    type,
    showInternalsWarning,
    showExternalsWarning,
  }) => {
    const isToggleType = propertyList[headers][0].display_type === "toggle";

    return (
      <>
        {propertyList[headers].map((header, index) => {
          if (orderItem.isContainerChild && !["width"].includes(header.uniq_id))
            return;

          if (isToggleType) {
            return renderOptions(
              header.uniq_id,
              header.options,
              headers !== "null" ? true : false,
              isToggleType,
              header.name,
              type,
              false,
              false,
              header.disabled
            );
          }

          return (
            <div
              className={`${headers !== "null" ? "pt-1" : "pt-3"}`}
              key={`${type}_${index}`}
            >
              <div className="d-flex pointer">
                <p
                  className={` ${
                    headers !== "null"
                      ? "m-0 text-capitalize sub-property-text"
                      : "text-uppercase property-name"
                  }`}
                >
                  {header.name}
                </p>
                {projectSettings[header.uniq_id] &&
                projectSettings[header.uniq_id]["overridden"] &&
                !secondaryProperties["null"].find(
                  (e) => e.uniq_id == header.uniq_id
                ).disabled ? (
                  <a
                    className="d-flex justify-content-center mt-2 pointer"
                    onClick={() => {
                      toggleOverrideConfirmation(!showMoreProperties);
                      setOverridePropertyIdentifier(header.uniq_id);
                    }}
                    style={{
                      textDecoration: "none",
                      marginLeft: "10px",
                      fontSize: "13px",
                    }}
                  >
                    <span>
                      <i className="fa-solid fa-rotate-left"></i>{" "}
                    </span>
                    <span style={{ marginLeft: "5px" }}> {"CLEAR"}</span>
                  </a>
                ) : (
                  <div></div>
                )}
              </div>

              {renderOptions(
                header.uniq_id,
                header.options,
                headers !== "null" ? true : false,
                isToggleType,
                header.name,
                type,
                showInternalsWarning,
                showExternalsWarning,
                header.disabled
              )}

              {header.uniq_id === "shutter_color" &&
                !header.disabled &&
                Object.keys(orderItem.shutter_configs).length > 0 && (
                  <div style={{ marginTop: "10px" }}>
                    <a
                      style={{ color: "#2C5FDF" }}
                      className="pointer"
                      onClick={toggleCustomizeShutters}
                    >
                      Customize Shutters
                    </a>
                    {customizeShutters && (
                      <ShutterCustomizationContainer
                        shutterConfigs={orderItem.shutter_configs}
                        setNotificationMessage={setNotificationMessage}
                        loadOrderItem={loadOrderItem}
                        projectId={projectId}
                        groupId={groupId}
                        orderItemId={orderItemId}
                        shutterColorOptions={header.options}
                      ></ShutterCustomizationContainer>
                    )}
                  </div>
                )}
            </div>
          );
        })}
        {headers === "Dimensions" &&
          (showInternalsWarning || showExternalsWarning) && (
            <div className="align-self-end h-50 pb-2">
              <span className="text-warn-orange fas fa-exclamation-circle pe-1"></span>
              {showInternalsWarning && showExternalsWarning && (
                <span className="text-warn-orange">
                  Reset Internals & Externals to change the dimensions
                </span>
              )}
              {!showInternalsWarning && showExternalsWarning && (
                <span className="text-warn-orange">
                  Reset Externals to change dimensions
                </span>
              )}
              {showInternalsWarning && !showExternalsWarning && (
                <span className="text-warn-orange">
                  Reset Internals to change dimensions
                </span>
              )}
            </div>
          )}
      </>
    );
  };

  const renderOptions = (
    rootIdentifier = "",
    options,
    isDropDown,
    isOptionsAsToggle,
    headerName,
    type = "product",
    showInternalsWarning,
    showExternalsWarning,
    disabled,
    nestedLevels = 1
  ) => {
    let optionChildren = null;
    let optionsAsPills = false;

    if (!options.length) return null;

    if (
      projectSettings[rootIdentifier] &&
      type === "project" &&
      !projectSettings[rootIdentifier]["overridden"]
    ) {
      options = options.map((option) => {
        option.fromProjectSettings = true;

        return option;
      });
    }

    if (nestedLevels === 1) {
      const hasChildren = options.some((option) => option.children.length);
      optionsAsPills = !hasChildren && options.length < 4 && !isDropDown;
    }

    if (isOptionsAsToggle) {
      options[0].level = nestedLevels;
      options[1].level = nestedLevels;

      return (
        <React.Fragment key={`toggle_${headerName}`}>
          <Option
            disabled={disabled}
            className={`default-option ${
              options[0].selected && !options[0].fromProjectSettings
                ? "selected-option"
                : ""
            }`}
            onClick={() => {
              handleOptionsChange(
                rootIdentifier,
                options[0].selected
                  ? options[1].identifier
                  : options[0].identifier
              );
            }}
          >
            {headerName.replace("Exposed Side ", "")}
          </Option>
        </React.Fragment>
      );
    }

    // TODO. Remove pill related code if not using anymore.
    if (optionsAsPills) {
      {
        return (
          <>
            <OptionsContainer className="d-flex flex-wrap pt-2">
              {options.map((option, index) => {
                option.level = nestedLevels;

                return (
                  <Option
                    disabled={disabled}
                    className={`rounded-1 default-option ${
                      option.selected && !option.fromProjectSettings
                        ? "selected-option"
                        : ""
                    }`}
                    key={option.identifier + "_" + index}
                    onClick={() => {
                      handleOptionsChange(rootIdentifier, option.identifier);
                    }}
                  >
                    {option.name}
                  </Option>
                );
              })}
            </OptionsContainer>
            {projectSettings[rootIdentifier] &&
            !projectSettings[rootIdentifier]["overridden"] ? (
              <div className="invalid-feedback d-block">
                {options.find((option) => option.selected).name}&nbsp;
                <i style={{ color: "black" }}>(project settings)</i>
              </div>
            ) : null}
          </>
        );
      }
    }

    if (!optionsAsPills && !isOptionsAsToggle) {
      return (
        <>
          <Select
            isDisabled={
              ((showInternalsWarning || showExternalsWarning) &&
                ["height", "width", "depth"].includes(rootIdentifier)) ||
              disabled
            }
            value={
              options.find(
                (option) => option.selected && !option.fromProjectSettings
              ) || null
            }
            className="mt-2"
            options={options.map((option, index) => {
              option.value = option.name;
              option.label = option.image ? (
                <div key={index}>
                  {option.image && (
                    <OptionImage
                      key={index}
                      src={option.image}
                      alt={option.name}
                      className="me-2 border border-dark rounded-circle"
                    />
                  )}
                  {option.name}
                </div>
              ) : (
                option.name
              );
              option.level = nestedLevels;

              if (option.selected) {
                optionChildren = option.children;
              }

              return {
                ...option,
              };
            })}
            onChange={(selectedOption) => {
              if (projectSettings[rootIdentifier]) {
                projectSettings[rootIdentifier]["overridden"] = true;
              }
              handleOptionsChange(rootIdentifier, selectedOption.identifier);
            }}
          />

          {projectSettings[rootIdentifier] &&
          !projectSettings[rootIdentifier]["overridden"] ? (
            <div className="invalid-feedback d-block">
              {options.find((option) => option.selected).name}&nbsp;
              <i style={{ color: "black" }}>(project settings)</i>
            </div>
          ) : null}
          {optionChildren &&
            renderOptions(
              rootIdentifier,
              optionChildren,
              false,
              isOptionsAsToggle,
              headerName,
              type,
              showInternalsWarning,
              showExternalsWarning,
              ++nestedLevels
            )}
        </>
      );
    }
  };

  const isDimensionNotValid = (dimension, dimension_range) => {
    return (
      dimension.length > 0 &&
      (!/^\d*$/.test(dimension) ||
        parseInt(dimension) < dimension_range.min_value ||
        parseInt(dimension) > dimension_range.max_value)
    );
  };

  const updateDimension = (dimension_key, dimension_range) => {
    const dimension_value = dimensions[dimension_key];
    const old_dimension_value = orderItem.dimensions.find(
      (e) => e.key === dimension_key
    )["value"];
    const invalid = isDimensionNotValid(dimension_value, dimension_range);

    if (
      dimension_value == old_dimension_value ||
      dimension_value == "" ||
      invalid
    ) {
      setDimensions({
        ...dimensions,
        [dimension_key]: old_dimension_value,
      });
      return;
    }

    setIsPropertiesMenuLoading(true);
    customizeOrderItemDimension({
      projectId,
      groupId,
      orderItemId,
      dimension: {
        key: dimension_key,
        value: dimension_value,
      },
    })
      .then((order_item) => {
        setOrderItem({
          ...orderItem,
          ...{ dimensions: order_item.dimensions },
        });
        setIsPropertiesMenuLoading(false);
        markBomSummaryStale(bomSummary, setBomSummary);
        loadRoom(currentRoom.id);
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({ type: "danger", text: error });
        loadOrderItem({ loader: true });
      })
      .finally((_) => setIsPropertiesMenuLoading(false));
  };

  return (
    <>
      {notificationMessage.text && (
        <Notification
          color={notificationMessage.type}
          isOpen={isNotificationVisible}
          toggle={onDismissNotification}
        >
          {notificationMessage.text}
        </Notification>
      )}

      {orderItem ? (
        <ProductContainer
          style={{
            "box-shadow": "none",
            border: "1px solid #dee2e6",
            "border-radius": 0,
            "border-top": "none",
          }}
        >
          {isBrowser && (
            <div className="d-flex justify-content-between align-items-center p-3">
              <div>
                <h4 className="my-2 text-muted" color="gray">
                  {orderItem.product.name}
                </h4>
              </div>

              <div className="position-relative">
                <div
                  className={`d-flex justify-content-evenly flex-wrap ${
                    params.projectId === undefined && "me-7"
                  }`}
                >
                  {}
                </div>
                {isBrowser && (
                  <CloseButtonContainer
                    top="-2.3rem"
                    right="-0.5rem"
                    guestview={
                      params.projectId === undefined ? "true" : "false"
                    }
                  >
                    <CloseButton
                      size="1.2em"
                      padding="10px"
                      className="ms-4"
                      onClick={() =>
                        navigate(
                          `/projects/${projectId}/rooms/${currentRoom.id}/canvas`
                        )
                      }
                    />
                  </CloseButtonContainer>
                )}
              </div>
            </div>
          )}
          {isMobile && (
            <Navbar>
              <ProductName>
                <Icon
                  className="fa-solid fa-arrow-left pointer fs-5"
                  onClick={() => navigate("/catalogs")}
                />
                <span className="ms-3">{orderItem.product.name}</span>
              </ProductName>
              <div className="d-flex flex-row align-items-center">
                <Icon
                  style={{ visibility: "hidden" }}
                  className="fa-solid fa-arrow-left pointer fs-5"
                  onClick={() => navigate("/catalogs")}
                />
              </div>
            </Navbar>
          )}
          <div className={`d-flex pb-4 ${isMobile && "flex-column-reverse"}`}>
            <div
              style={{ flexGrow: 1, width: "65%" }}
              className="position-relative px-3"
            >
              {orderItemId && !orderItem.isContainerChild && (
                <ToggleButton
                  onClick={(newToggleState) => toggleHandler(newToggleState)}
                />
              )}
              {toggleState === "product" && (
                <div className="flex-row">
                  <ProductInfoContainer
                    className="px-3"
                    browser={isBrowser.toString()}
                  >
                    <div
                      className={`${
                        isMobile &&
                        "d-flex align-items-center flex-row-reverse justify-content-center"
                      }`}
                      style={{
                        ...(isMobile && { gap: "25px", margin: "15px" }),
                      }}
                    >
                      <ProductImgContainer className="d-flex justify-content-center align-items-center mt-3 mb-4">
                        {renderCarousel()}
                      </ProductImgContainer>
                      <ThumbnailContainer
                        className={`d-flex ${
                          isBrowser
                            ? "justify-content-center mb-4"
                            : "flex-column"
                        }`}
                      >
                        {orderItem.product.images.map((image, index) => (
                          <Thumbnail
                            browser={isBrowser.toString()}
                            onClick={() => next(index)}
                            className={`pointer d-flex justify-content-center align-items-center p-1 ${
                              index === activeIndex ? "selected-thumbnail" : ""
                            }`}
                            key={index}
                          >
                            <img className="mh-100 mw-100" src={image} />
                          </Thumbnail>
                        ))}
                      </ThumbnailContainer>
                    </div>
                  </ProductInfoContainer>
                  <PropertiesContainer
                    browser={isBrowser.toString()}
                    height={params.projectId === undefined ? "80vh" : "68vh"}
                    className={`px-3 pb-0 properties-container w-65`}
                  >
                    {isPropertiesMenuLoading && (
                      <CustomizationSpinnerContainer>
                        <Spinner />
                      </CustomizationSpinnerContainer>
                    )}
                    <div
                      className={`${isPropertiesMenuLoading ? "blurred" : ""}`}
                    >
                      <div>
                        <p className="mt-3 text-uppercase property-name">
                          Dimensions
                        </p>
                        <Form className="d-flex pt-1 gap-4">
                          {orderItem.dimensions.map((dimension, index) => (
                            <ProjectSettingsFormGroup key={index}>
                              <p className="m-0 text-capitalize sub-property-text">
                                {dimension.key}
                              </p>
                              <DimensionInput
                                disabled={isOrderFinalised}
                                value={dimensions[dimension.key]}
                                onChange={(ev) =>
                                  setDimensions({
                                    ...dimensions,
                                    [dimension.key]: ev.target.value,
                                  })
                                }
                                onBlur={() =>
                                  updateDimension(dimension.key, {
                                    min_value: dimension.min_value,
                                    max_value: dimension.max_value,
                                  })
                                }
                                invalid={isDimensionNotValid(
                                  dimensions[dimension.key],
                                  {
                                    min_value: dimension.min_value,
                                    max_value: dimension.max_value,
                                  }
                                )}
                              />
                              <FormFeedback invalid>
                                {`Range: ${dimension.min_value} to ${dimension.max_value}`}
                              </FormFeedback>
                            </ProjectSettingsFormGroup>
                          ))}
                        </Form>
                      </div>

                      {Object.keys(orderItem.property_list).map(
                        (headers, index) => {
                          if (
                            headers === "Exposed Sides" &&
                            orderItem.isContainerChild
                          ) {
                            return;
                          }

                          return (
                            <div key={index}>
                              <div>
                                {headers !== "null" ? (
                                  <p className="mt-3 text-uppercase property-name">
                                    {headers}
                                  </p>
                                ) : (
                                  ""
                                )}
                                {
                                  <div
                                    key={`headers_${index}`}
                                    className={getClassForRenderingProperties({
                                      headers,
                                      displayType:
                                        orderItem.property_list[headers][0]
                                          .display_type,
                                    })}
                                  >
                                    {renderProperties({
                                      propertyList: orderItem.property_list,
                                      headers,
                                      type: "product",
                                      showInternalsWarning:
                                        orderItem.isSpaceConfigChanged,
                                      showExternalsWarning:
                                        orderItem.isShutterSizeConfigChanged,
                                    })}
                                  </div>
                                }
                              </div>
                            </div>
                          );
                        }
                      )}
                      {!orderItem.isContainerChild && (
                        <div className="d-flex justify-content-center border border-gray bg-light align-content-center p-2 my-3 cursor">
                          {!showMoreProperties ? (
                            <div
                              className="d-flex pointer"
                              onClick={() =>
                                setShowMoreProperties(!showMoreProperties)
                              }
                            >
                              Show More
                            </div>
                          ) : (
                            <div
                              className="d-flex pointer"
                              onClick={() =>
                                setShowMoreProperties(!showMoreProperties)
                              }
                            >
                              Show Less
                            </div>
                          )}
                        </div>
                      )}

                      {showMoreProperties && (
                        <>
                          {Object.keys(secondaryProperties).map(
                            (headers, index) => (
                              <div key={`project_${index}`}>
                                <div>
                                  {headers !== "null" && (
                                    <p className="mt-3 text-uppercase property-name">
                                      {headers}
                                    </p>
                                  )}
                                  <div
                                    className={getClassForRenderingProperties({
                                      headers,
                                      displayType:
                                        secondaryProperties[headers][0]
                                          .display_type,
                                    })}
                                  >
                                    {renderProperties({
                                      propertyList: secondaryProperties,
                                      headers,
                                      type: "project",
                                    })}
                                  </div>
                                </div>
                              </div>
                            )
                          )}
                          {!orderItem.isContainerChild && orderItemId && (
                            <div>
                              <p className="mt-3 text-uppercase property-name d-flex align-items-start">
                                <span>Attachments</span>
                              </p>

                              {attachments.length > 0 ? (
                                <div>
                                  <ListGroup numbered flush>
                                    {attachments.map((attachment, index) => (
                                      <ListGroupItem
                                        key={index}
                                        className="d-flex align-items-center"
                                      >
                                        <div className="d-flex justify-content-between align-items-center w-100">
                                          <span
                                            className="ms-1"
                                            style={{ width: "130px" }}
                                          >
                                            {attachment.filename}
                                          </span>

                                          <div>
                                            <a href={attachment.url}>
                                              <Icon className="fa-solid fa-download pointer" />
                                            </a>

                                            {showDeleteConfirmation && (
                                              <ConfirmationModal
                                                isOpen={showDeleteConfirmation}
                                                toggle={
                                                  toggleDeleteConfirmation
                                                }
                                                onConfirm={() =>
                                                  handleDeleteAttachment(
                                                    attachment.blob_id
                                                  )
                                                }
                                                message="Are sure you want to delete this Attachment?"
                                                headingText="Confirm Deletion"
                                              />
                                            )}

                                            <Icon
                                              className="fa-regular fa-trash-can ms-3 pointer"
                                              size="16px"
                                              title="Delete Attachment"
                                              onClick={toggleDeleteConfirmation}
                                            />
                                          </div>
                                        </div>
                                      </ListGroupItem>
                                    ))}
                                  </ListGroup>
                                </div>
                              ) : (
                                <span
                                  className="d-flex justify-content-left mt-1"
                                  style={{ color: "#CCC" }}
                                >
                                  {!isPropertiesMenuLoading
                                    ? "No Attachments!"
                                    : "Loading Attachments..."}
                                </span>
                              )}
                              {showAttachmentForm && (
                                <Form>
                                  <FormGroup className="mt-3 d-flex justify-content-space-between">
                                    <Input
                                      id="label"
                                      name="label"
                                      type="text"
                                      placeholder="Label"
                                      value={label}
                                      className="me-3 w-50"
                                      onChange={(e) => setLabel(e.target.value)}
                                    />
                                    <div className="d-flex align-items-end justify-content-space-between">
                                      <Label for="attachments" className="mb-0">
                                        <Button
                                          className="btn btn-success pointer d-flex"
                                          disabled={!label}
                                          onClick={() =>
                                            hiddenFileInput.current.click()
                                          }
                                        >
                                          <span className="fw-bold">
                                            Upload
                                          </span>
                                          <Icon className="fa-solid fa-upload pointer ms-3 d-flex justify-content-center " />
                                        </Button>
                                      </Label>
                                      <Input
                                        id="attachments"
                                        name="file"
                                        type="file"
                                        disabled={!label}
                                        accept="image/*,.pdf"
                                        className="d-none"
                                        innerRef={hiddenFileInput}
                                        onChange={(e) => {
                                          handleAttachmentUpload(
                                            e.target.files[0]
                                          );
                                        }}
                                      />
                                      <a
                                        onClick={handleCancel}
                                        className="ms-3 pointer"
                                      >
                                        Cancel
                                      </a>
                                    </div>
                                  </FormGroup>
                                </Form>
                              )}
                              <div className="p-2 ps-0 d-flex mt-2">
                                <Button
                                  onClick={handleToggleForm}
                                  outline
                                  size="sm"
                                >
                                  <i className="fa-solid fa-circle-plus me-2"></i>
                                  Add Attachment
                                </Button>
                              </div>
                            </div>
                          )}
                          {!orderItem.isContainerChild && orderItemId && (
                            <FormGroup>
                              <Label for="Remarks">
                                <p className="mt-3 text-uppercase property-name d-flex align-items-start">
                                  <span>Remarks</span>
                                </p>
                              </Label>
                              <Input
                                id="Remarks"
                                name="text"
                                type="textarea"
                                placeholder="Type your remarks here"
                                value={remarks || ""}
                                onChange={(e) => setRemarks(e.target.value)}
                                onBlur={handleRemarks}
                              />
                            </FormGroup>
                          )}
                        </>
                      )}
                    </div>
                  </PropertiesContainer>
                </div>
              )}
              {toggleState == "spaceConfig" && (
                <SpaceConfig
                  orderItemId={orderItemId}
                  groupId={groupId}
                  projectId={projectId}
                  parentCallback={handleOrderItemUpdate}
                />
              )}
              {toggleState == "shutterConfig" && (
                <ShutterConfig
                  orderItemId={orderItemId}
                  groupId={groupId}
                  projectId={projectId}
                  parentCallback={handleOrderItemUpdate}
                />
              )}
              {toggleState == "cutlist" && (
                <Cutlist
                  orderItemId={orderItemId}
                  groupId={groupId}
                  projectId={projectId}
                  showcolor={true}
                />
              )}
            </div>
          </div>
        </ProductContainer>
      ) : null}

      <ConfirmationModal
        isOpen={removeOverrideConfirmationOpen}
        toggle={toggleOverrideConfirmation}
        onConfirm={() =>
          handleRemoveProjectOverride(overridePropertyIdentifier)
        }
        message="Are you sure you want to use the Project Settings ?"
        headingText="Confirm Remove Override"
      />
    </>
  );
}

export default Personalize;
